<template>
  <div id="app" class="container d-flex justify-content-center px-0">
    <link rel="preconnect" href="https://fonts.gstatic.com" />
    <link href="https://fonts.googleapis.com/css2?family=Mulish:wght@200;300;400;500;600;700;800;900&family=Poppins:wght@100;200;300;400;500;600;700;800;900&display=swap" rel="stylesheet" />
    <!--    <div id="nav">-->
    <!--      <router-link to="/">Home</router-link> |-->
    <!--      <router-link to="/about">About</router-link>-->
    <!--    </div>-->
    <div id="main_component_wraper" style="width:100%">
      <div class="close-btn" @click="closeCanaryWidget" v-if="display_close_button && isShowClose">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z" fill="#8997B1" />
        </svg>
      </div>
      <router-view />
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      response: null,
      kitRef: null,
      display_close_button: false,
      isShowClose:true
    };
  },
  methods: {
    closeCanaryWidget() {
      if (!this.$fromAdminSide) {
        parent.postMessage({ launcherScreen: true }, "*");
      }
    },
  },
  created() {
    if (this.$route.query.kit_ref) {
      this.kitRef = this.$route.query.kit_ref;
    }
    if (this.$route.query.unique_url) {
      this.isShowClose = false;
    }
    setTimeout(() => {
      this.response = this.$session.get("response");
    }, 100);
  },
  mounted() {
    global.event.$on("display_close_button", (display_close_button) => {
      this.display_close_button = display_close_button;
    });
    window.addEventListener(
      "message",
      (event) => {
        if (event.origin === "http://localhost:8100" || event.origin === "https://vkstg.larkbase.com" || event.origin === "https://app.vouchkick.com") {
          if (event.data.settings) {
            this.response = this.$session.get("response");
            for (let key in event.data.settings) {
              if (key === "display_close_button") {
                this.response.settings[key] = event.data.settings[key];
                this.display_close_button = event.data.settings.display_close_button;
              }
            }
            this.$session.set("response", this.response);
          }
        }
      },
      false
    );
  },
};
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

.form-control:focus {
  border-color: var(--accent-color) !important;
  box-shadow: 0px 0px 0px 0.05rem var(--accent-color) !important;
}
.close-btn {
  text-align: end;
  padding-right: 5px;
  cursor: pointer;
}
body {
  background-color: #f1f2f9;
}

.custom-checkbox {
  /* The container */
  .container {
    display: block;
    position: relative;
    // padding-left: 35px;
    // margin-bottom: 12px;
    cursor: pointer;
    font-size: 22px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    /* Hide the browser's default checkbox */

    input {
      position: absolute;
      opacity: 0;
      cursor: pointer;
      height: 0;
      width: 0;
    }
  }

  /* Create a custom checkbox */
  .checkmark {
    position: absolute;
    top: 0;
    left: 0;
    height: 18px;
    width: 18px;
    background-color: #ffff;
    border-radius: 4px;
  }

  /* On mouse-over, add a grey background color */
  .container:hover input ~ .checkmark {
    background-color: #ffff;
  }

  /* When the checkbox is checked, add a blue background */
  .container input:checked ~ .checkmark {
    background-color: var(--accent-color);
  }

  /* Create the checkmark/indicator (hidden when not checked) */
  .checkmark:after {
    content: "";
    position: absolute;
    display: none;
  }

  /* Show the checkmark when checked */
  .container input:checked ~ .checkmark:after {
    display: block;
  }

  /* Style the checkmark/indicator */
  .container .checkmark:after {
    left: 6px;
    top: 2px;
    width: 6px;
    height: 11px;
    border: solid #ffff;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
  }
}
.modal-body {
  padding: 32px !important;
  position: relative !important;
  text-align: left;

  .close {
    position: absolute;
    top: 18px;
    right: 15px;
    opacity: 1;
  }

  .modal-title {
    font-family: "Poppins", sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0.01em;
    color: #313c4e;
    margin-bottom: 18px;
  }

  .modal-desc {
    font-family: "Poppins", sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 13px;
    line-height: 20px;
    letter-spacing: 0.01em;
    color: #313c4e;
    margin: 0;
  }

  .link {
    color: var(--accent-color);
  }
}
.btn:hover {
  // color: var(--action-btn-color) !important;
  opacity: 0.9;
}

.vjs-poster {
  background-size: 100% !important;
  background-color: var(--background-color) !important;
}
</style>
